module.exports = __webpack_public_path__ + "img/hotelFamily-4.36b9d561.jpg";